import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CareIllustration from './CareIllustration';

export default function TransplantMilestone({ compact = false }) {
  const [milestone, setMilestone] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      try {
        const response = await fetch('/api/setting', { signal: controller.signal, cache: 'no-store' });
        if (!response.ok) throw new Error('Unavailable');
        const result = await response.json();
        if (!result.success) throw new Error('Unavailable');
        const points = result.data?.transplantTargetPoints;
        const target = Number.isFinite(points) && points > 0 ? { points } : null;
        setMilestone(target ? { ...target, currentPoints: result.data.transplantCurrentPoints ?? 0 } : null);
        setError(!target);
      } catch (e) { if (e.name !== 'AbortError') setError(true); }
    }
    load();
    const interval = window.setInterval(() => { if (!document.hidden) load(); }, 30000);
    const refresh = () => { if (!document.hidden) load(); };
    window.addEventListener('focus', refresh);
    return () => { controller.abort(); window.clearInterval(interval); window.removeEventListener('focus', refresh); };
  }, []);
  const progress = milestone && <><span>{Number(milestone.currentPoints).toLocaleString('en-IN')} / {milestone.points.toLocaleString('en-IN')} points</span><progress aria-label="Company transplant milestone progress" max={milestone.points} value={Math.min(milestone.currentPoints, milestone.points)} /></>;
  if (compact) return <a href="/#transplant-milestone" className="nc-transplant-sticky" aria-label="View transplant milestone">{milestone ? <><span>Transplant milestone</span>{progress}</> : <span>{error ? 'Transplant progress unavailable' : 'Loading transplant progress…'}</span>}</a>;
  return <section id="transplant-milestone" className="container nc-section" aria-labelledby="transplant-title">
    <div className="nc-transplant">
      <div className="nc-transplant-copy">
        <span className="nc-eyebrow">OUR TRANSPLANT MILESTONE</span>
        <h2 id="transplant-title">Care points.<br />A chance to change a life.</h2>
        <p>NephroCore’s free kidney transplant milestone brings a bigger purpose to care points, for patients and doctors.</p>
        <div className="nc-transplant-paths">
          <div><h3>Awarded by NephroCore</h3><p>The company can award transplant support through its review process.</p></div>
          <div><h3>Redeem your care points</h3><p>Meet the points threshold and request the transplant reward from your account. Requests are reviewed by NephroCore.</p></div>
        </div>
        <div className="nc-transplant-actions"><Link className="nc-button" to="/login">View your care points <span aria-hidden="true">→</span></Link><Link className="nc-text-link" to="/contact">Ask about transplant support →</Link></div>
      </div>
      <div className="nc-transplant-target">
        <CareIllustration kind="heart" />
        <span className="nc-eyebrow">FREE KIDNEY TRANSPLANT</span>
        {milestone ? <div className="nc-transplant-progress">{progress}<small>50 points per paid membership · 5 per paid appointment or test booking</small></div> : <p role="status">{error ? 'The current threshold is unavailable. Please contact our care team.' : 'Loading the current points threshold…'}</p>}
        <p>Explore the milestone without signing in. Sign in to see your own balance and eligibility.</p>
      </div>
    </div>
  </section>;
}
